<div class="card">
    <div class="cardTitle">
        <h2>{{ 'listing.save.saveOptions.label' | translate }}</h2>
    </div>

    <div class="cardContent">
        @for (section of sections(); track section.part) {
            <section class="part">
                <div class="partHeader">
                    <span class="partHeader__icon"><i class="{{ section.icon }}"></i></span>
                    <h3>{{ section.title | translate }}</h3>
                    @if (section.status; as status) {
                        <span class="partStatus partStatus--{{ status.tone }}">{{ status.label | translate }}</span>
                    }
                </div>

                <div class="partBody">
                    @switch (section.phase) {
                        @case (ListingPartPhase.LOADING) {
                            <app-loader type="spinner" [alwaysShow]="true"></app-loader>
                        }
                        @case (ListingPartPhase.LOCKED) {
                            <p class="partMessage">{{ 'listings.header.publishingInProgress' | translate }}</p>
                        }
                        @case (ListingPartPhase.UNAVAILABLE) {
                            <p class="partMessage">{{ 'listing.save.visualsUnavailableMessage' | translate }}</p>
                        }
                        @default {
                            @for (option of section.options; track option.title) {
                                @let isBlocked = isOptionBlocked(section, option);
                                <div
                                    class="saveOption"
                                    [class.selected]="section.selectedAction === option.action"
                                    [class.disabled]="isBlocked || isRunning()"
                                    (click)="selectAction(section, option)"
                                >
                                    <div class="content">
                                        <span class="radio"></span>
                                        <div class="title">
                                            <span class="optionTitle">
                                                <i class="{{ option.icon }}"></i>
                                                {{ option.title | translate }}
                                            </span>
                                            <span class="optionSubtitle">
                                                @if (isBlocked) {
                                                    {{
                                                        'listing.save.blockedByValidationErrors' | translate: { count: section.errorCount }
                                                    }}
                                                } @else {
                                                    {{ option.description | translate }}
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    @if (
                                        option.action === PartAction.RETURN_TO_EDITOR &&
                                        section.selectedAction === PartAction.RETURN_TO_EDITOR
                                    ) {
                                        <textarea
                                            class="optionDescription"
                                            placeholder="{{ 'listing.save.descriptionPlaceholder' | translate }}"
                                            [disabled]="isRunning()"
                                            [(ngModel)]="rejectReasons[section.part]"
                                            (click)="$event.stopPropagation()"
                                        ></textarea>
                                    }
                                </div>
                            }
                        }
                    }
                </div>
            </section>
        }
    </div>

    <div class="cardFooter">
        <footer class="buttonArea stickyBottom centeredButtons">
            @if (hasFailure()) {
                <button type="button" class="button primary" (click)="closeAndReload()">
                    {{ 'generalKeywords.close' | translate }}
                </button>
            } @else {
                <button type="submit" class="button primary with-loader" [disabled]="!canConfirm() || isRunning()" (click)="confirm()">
                    @if (isRunning()) {
                        <app-loader type="spinner" [alwaysShow]="true"></app-loader>
                    }
                    {{ 'generalKeywords.confirm' | translate }}
                </button>
                <button type="button" class="button" [disabled]="isRunning()" (click)="closeModal()">
                    {{ 'generalKeywords.cancel' | translate }}
                </button>
            }
        </footer>
    </div>
</div>
